export default __webpack_public_path__ + "static/media/gallery-wip-grenade_10.621dbf2b.jpg";